import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { ParentService } from 'src/app/admin/services/parent.service';
import { SidenavActions, SideNavService } from 'src/app/admin/services/side-nav.service';
import { faBell, faCalendar, faChevronLeft, faChevronRight, faDownload, faMedkit, faPlus, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentsDialogComponent } from 'src/app/shared/appointments-dialog/appointments-dialog.component';
import { AlbumDialogComponent } from 'src/app/shared/album-dialog/album-dialog.component';
import { ProfilePictureDialogComponent } from 'src/app/shared/profile-picture-dialog/profile-picture-dialog.component';
import { Parent } from 'backend/interfaces/parent.interface';

import { Business } from 'backend/interfaces/business.interface';
import { ChatService } from 'src/app/services/chat.service';
import { BusinessDataService } from 'src/app/business/services/data.service';

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})

export class ViewUserComponent implements OnInit {
  currentUser;
  parentAppointments;
  loading;
  user: Parent;
  faMedkit = faMedkit;
  faUser = faUser;
  faPlus = faPlus;
  faBell = faBell;
  faTimes  = faTimes;
  faCalendar = faCalendar; 
  faDownload = faDownload;
  parentFiles = [];
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  view: CalendarView = CalendarView.Week;
  CalendarView = CalendarView;
  sideNavActions = SidenavActions;
  viewDate: Date = new Date();
  refresh = new Subject<void>();
  events: CalendarEvent[] = [
  ];
  selectedLocation: string = 'All';
  event: CalendarEvent;
  newBookingForm: UntypedFormGroup;
  activeDayIsOpen: boolean = true;
  businesses = [];

  constructor(private authService: AuthService, private dataService: BusinessDataService, private appointmentService: AppointmentService, private parentService: ParentService, private router: Router, public dialog: MatDialog, public sidenav: SideNavService, private chatService: ChatService, private ar: ActivatedRoute) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    const parentId = this.ar.snapshot.params['id'];
    this.parentService.getParentById(parentId);
    this.parentService.activatedParent$.subscribe(res => {
      if(res){
        this.currentUser = res;
        this.user = {
          Name: res.Name,
          Surname: res.Surname,
          ID: res.ID,
          Address: res.Address,
          Mobile: res.Mobile,
          Email: res.Email
        }
      }
    });
    this.dataService.businesses$.subscribe(res => {
      if (res) {
        this.businesses = res;
      }
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // this.loading = true;
    // this.authService.$User.subscribe(async (res)=>{
    //   if(res){
    //     this.currentUser = await res.get('username');
    //     this.tempParent = {Name: res.get('Name'), Surname: res.get('Surname'), Email: this.currentUser, Mobile: res.get('Mobile')}
    //     await this.parentService.getParentByEmail(this.currentUser).then(res => {
    //       this.parent = res;
    //     });
    //     await this.parentService.getStudentsByParentId(this.parent?.ID).then(res => {
    //       this.students = res;
    //     });
    //     if(this.parent?.AlbumId){
    //       await this.parentService.getparentFiles(this.parent.AlbumId).then(res => {
    //         this.parentFiles = res;
    //       }).catch(err => console.log('err: ', err));
    //     }
    //   }
    // })
    // setTimeout(() => {
    //   this.loading = false;
    // }, 2000);
  }
  

  createParent(): void {
    this.router.navigate(['parent', 'profile']);
  }

  openParent(){
    console.log('todo parent edit');
  }

  viewAlbum(){
    const dialogRef = this.dialog.open(AlbumDialogComponent, {
      data: {parentId: this.user.ID, files: this.parentFiles },
      width: '90%',
      maxWidth: '100vw',
      height: '90%',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  download() {
    const linkSource = this.user.Document;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource.source;
    downloadLink.target = '_blank';
    downloadLink.download = linkSource.name;
    downloadLink.click();
  }

  viewAppointments(){
    const dialogRef = this.dialog.open(AppointmentsDialogComponent, {
      data: {appointments: this.parentAppointments, parentId: (this.user ? this.user.ID : this.currentUser) },
      width: '60%'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  
  
  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (moment(date).isSame(this.viewDate, 'month')) {
      if (
        (moment(this.viewDate).isSame(date, 'day') && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    event.start = newStart;
    event.end = newEnd;

  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  openSideNav(e: CalendarEvent): void {
    this.appointmentService.setAppointment(e);
    if(e.id){
      this.sidenav.open(this.sideNavActions.UpdateAppointment);
    } else {
      this.sidenav.open(this.sideNavActions.NewAppointment);
    }
  }

  createProfile(): void {
    this.parentService.newParentEmail = this.currentUser;
    this.sidenav.open(this.sideNavActions.NewParent);
  }

  updateLoader(e: boolean){
    this.loading = e;
  }

  openProfilePictureDialog(src?: any): void {
    const dialogRef = this.dialog.open(ProfilePictureDialogComponent, {
      data: {title: 'Upload Picture', parentId: this.user.ID, currentPicture: src ? src : ''},
      width: '60%'
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        console.log(result);
      } else {
        this.dialog.closeAll();
      }
    });
  }

  viewProfile(): void {
    this.router.navigate(['parent', 'child'])
  }

  loadProfile(parent: Parent): void {
    this.router.navigate(['parent','account'])
  }

  async openBusinessmarketing(business: Business){
    this.loading = true;
    this.dataService.business.next(business);
    this.chatService.getChats(business.id);
    await this.dataService.getAdsByBusinessId(business.id);
    this.loading = false;
  }

}
